import { Theme, ThemeOptions } from '@mui/material'

export default (theme: Theme): ThemeOptions['components'] => ({
    MuiButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                whiteSpace: 'nowrap',
                '&.edgeStart': {
                    marginLeft: theme.spacing(-1),
                },
                '&.edgeEnd': {
                    marginRight: theme.spacing(-1),
                },
                '&.fullWidthOnMobile': {
                    [theme.breakpoints.down('sm')]: {
                        width: '100%',
                    },
                },
            }),
            containedPrimary: {
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
            startIcon: {
                marginRight: 4,
            },
            endIcon: {
                marginLeft: 4,
            },
        },
    },
})
